import React, { useEffect, useState } from 'react';
import './LoadingAnimation.css';

const LoadingAnimation: React.FC = () => {
  const [theme, setTheme] = useState<'light' | 'dark'>('dark');

  useEffect(() => {
    // Get theme from localStorage immediately
    // Default to 'light' for public pages
    const savedTheme = localStorage.getItem('crypxa_public_theme') as 'light' | 'dark' | null;
    if (savedTheme === 'light' || savedTheme === 'dark') {
      setTheme(savedTheme);
      // Also set it on documentElement to ensure CSS works
      document.documentElement.setAttribute('data-theme', savedTheme);
    } else {
      // Default to light for public pages
      setTheme('light');
      document.documentElement.setAttribute('data-theme', 'light');
    }
  }, []);

  return (
    <div className="loading-container" data-theme={theme}>
      <div className="loading-content">
        <img 
          src="/images/CRYPXA_Loading_Icon.png" 
          alt="Loading" 
          className="loading-icon"
        />
      </div>
    </div>
  );
};

export default LoadingAnimation;

